
<app-title-component [data]="{name : 'Utilisateurs'}"></app-title-component>

<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
  <mat-card-header class="d-flex align-items-center justify-content-end p-3 border-bottom">
      <app-search-bar-component (searchBarValue)="applyFilter($event)" [width]="100" appearance="outline"></app-search-bar-component>
  </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
      <!--loading-->
      @if(loading){
        <div class="loading-table-shade">
          <mat-spinner diameter="70" color="primary"></mat-spinner>
        </div>
      }
      <!---->
      <!---->
     <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
        <!-- -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
          <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.id}} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Nom & Prenom </th>
          <td mat-cell *matCellDef="let row" class="fw-semibold text-dark" data-label="Nom & Prenom"> {{row.name | uppercase }} </td>
        </ng-container>


        <!-- -->
        <ng-container matColumnDef="profil">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Profil </th>
          <td mat-cell *matCellDef="let row"  data-label="Profil"> {{row.profil_name | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Genre </th>
          <td mat-cell *matCellDef="let row"  data-label="Genre"> {{row.gender | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="adresse">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Adresse </th>
          <td mat-cell *matCellDef="let row"  data-label="Adresse"> {{row.adresse | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Etat </th>
          <td mat-cell *matCellDef="let row"  data-label="Etat">
              @if(row.disable){
                <span class="badge-status status-inactive">Désactivé</span>
              } @else {
                <span class="badge-status status-active">Actif</span>
              }
          </td>
        </ng-container>


        <!-- -->
        <ng-container matColumnDef="site_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Bureaux </th>
             <td mat-cell *matCellDef="let row"  data-label="Bureaux"> {{row.site_name | uppercase }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="groupe_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Groupe </th>
             <td mat-cell *matCellDef="let row"  data-label="Bureaux"> {{row.groupe_name | uppercase }} </td>
        </ng-container>

        <!-- -->

        <!-- Action -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef sticky="true" class="table-row-actions"> Actions </th>
           <td mat-cell *matCellDef="let row" class="table-row-actions">
            <button (click)="onChange(row)" [matTooltip]="row.disable?'Debloquer':'Bloquer'" matButton="" color="primary" type="button">
              @if (row.disable) {<mat-icon style="color: rgb(0, 95, 0);">frame_person</mat-icon>}
              @else {<mat-icon style="color: rgb(194, 126, 0);">frame_person_off</mat-icon>}

            </button>
            <button matTooltip="modifier" (click)="openUpdateUserModal(row)" matButton="" color="primary" type="button">
              <mat-icon class="text-muted-icon">edit</mat-icon>
            </button>
            <button matTooltip="supprimer" (click)="confirm(row)" matButton="" color="warn" type="button">
               <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
        </tr>
            </table>
      </div>
  </mat-card-content>

  <div class="border-top bg-white">
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</mat-card>

